import { render, staticRenderFns } from "./ruleExplainDialog.vue?vue&type=template&id=504891a5&scoped=true"
import script from "./ruleExplainDialog.vue?vue&type=script&lang=js"
export * from "./ruleExplainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504891a5",
  null
  
)

export default component.exports